"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.isplainobject"));

var _lodash2 = _interopRequireDefault(require("lodash.map"));

var _lodash3 = _interopRequireDefault(require("lodash.mapvalues"));

var deepObjectMap = function deepObjectMap(mapper) {
  var applyMapper = function applyMapper(obj) {
    if ((0, _lodash["default"])(obj)) {
      var x = (0, _lodash3["default"])(obj, applyMapper);
      return mapper(x);
    }

    if (Array.isArray(obj)) {
      return (0, _lodash2["default"])(obj, applyMapper);
    }

    return obj;
  };

  return applyMapper;
};

var _default = deepObjectMap;
exports["default"] = _default;